import { render, staticRenderFns } from "./EdmCampaignList.vue?vue&type=template&id=e332110e&scoped=true&"
import script from "./EdmCampaignList.vue?vue&type=script&lang=js&"
export * from "./EdmCampaignList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e332110e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VListItemContent } from 'vuetify/lib/components/VList';
installComponents(component, {VListItemContent})
